import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import { Tooltip } from '@material-ui/core';

export const DoubleField = ({ title, description, tooltip, descriptionWordsBreak = false, ...props }) => {
  const wordBreak = !descriptionWordsBreak ? 'normal' : typeof descriptionWordsBreak === 'boolean' ? 'break-all' : descriptionWordsBreak;
  const doubleField =
    <Box {...props}>
      <Typography sx={{ color: 'text.secondary', minWidth: 180 }}>{title}</Typography>
      <Typography sx={{
        fontWeight: 500,
        fontSize: '20px',
        wordBreak,
      }}
      >
        {description}
      </Typography>
  </Box>;

  return (
    tooltip ?
      <Tooltip title={tooltip} arrow>
        {doubleField}
      </Tooltip> :
      doubleField
  );
}

DoubleField.propTypes = {
  title: PropTypes.string,
  tooltip: PropTypes.string,
  description: PropTypes.any,
  descriptionWordsBreak: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
  ]),
};
